<template>
  <div class="box">
    <!-- 标题nav -->
    <div class="title_nav media_box" :style="{ transform: `translateX(${-scrollLeft}px)`}">
            <div class="first_top">
                <div class="logo">
                    <!-- <img :src="logo" alt="" /> -->
                    <img src="https://img.fencerspage.com/upload/oss/club/contest/20240522/1119664da8a77879f.png" alt="" />
                </div>
                <div class="title" id="navbar">
                  <div @click="goNavPage(item.id)" class="sm_title" v-for="(item, index) in titleList" :key="index">
                    {{ item.name }}
                  </div>
                </div>
            </div>
        </div>
    <div class="title_height"></div>
  </div>
  
</template>

<script>
export default {
  name: 'navBox',
  props:['page'],
  data(){
    return{
      logo: "https://img.fencerspage.com/upload/oss/club/contest/20240522/1119664da8a77879f.png",
      titleList: [
        { name: "约剑官网", id: 1 },
        { name: "约剑简介", id: 2 },
        { name: "探索多元化业务", id: 3 },
        { name: "案例展示", id: 4 },
        { name: "商务合作", id: 5 },
        { name: "服务与支持", id: 6 },
        { name: "应用与下载", id: 7 },
      ],
      scrollLeft:0, // 横向滚动距离
    }
  },

  mounted(){
    console.log(38,this.page)
    window.addEventListener('scroll', this.handleScroll);
  },

  methods:{
    // 标题栏获取横向滚动距离
    handleScroll() {
      this.scrollLeft = window.scrollX || window.pageXOffset;
    },

    goPage(url){
      this.$router.push({ path: url})
    },

    goNavPage(id){
      if(id=='1' && this.page!='HomePage'){
        // 1 首页
        this.goPage('/')
      }else if(id=='2' && this.page!='Introduction'){
        // 2 简介
        this.goPage('/Introduction')
      }else if(id=='3' && this.page!='Explore'){
        // 3 多元化业务
        this.goPage('/ExplorePage')
      }else if(id=='4' && this.page!='Display'){
        // 4 案例展示
        this.goPage('/DisplayPage')
      }else if(id=='5' && this.page!='Cooperation'){
        // 5 商务合作
        this.goPage('/CooperationPage')
      }else if(id=='6' && this.page!='Serve'){
        // 6 服务与支持
        this.goPage('/ServePage')
      }else if(id=='7'){
        // 7 应用与下载
        if(this.page=='HomePage'){
          this.$emit('scrollToBottom')
        }else{
          this.goPage('/HomeComponent?pageForm=secondary')
        }
      }
    }
  },

  beforeDestroy() {
    // 移除滚动事件监听
    window.removeEventListener('scroll', this.handleScroll);
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
$media_num: 1200px;  // 屏幕宽度

.media_box{
    width: 100vw;
    height: 50vw;
    font-size: 0.88vw; /*17*/
  
    /* $media_num */
    @media only screen and (max-width: 1200px) {
      width: 1200px;
      height:600px;  /*0.5*width*/ 
      /* height: calc(var($media_num)*0.5); // 0.5*width */
      font-size:10.6px; /*0.00885*$media_num*/ 
    }
  }

  /* 顶部标题 */
  .title_height{
    height: 5vw;
    width: 100%;

    @media only screen and (max-width:$media_num) {
      height:60px;
    }
  }

  .title_nav{
    height: 5vw;
    width: 100%;
    position: fixed ;
    background-color: #000;
    color: #fff;
    z-index: 999;

    @media only screen and (max-width:$media_num) {
      width: 1200px;
      height:60px;
    }

    .first_top {
      height: 100%;
      width: 73%;
      /* background-color: pink; */
      position: absolute;
      left: 0;
      top:0;
      display: flex;
      align-items: center;
  
  
      .logo {
        width: 3.2%; /*31*/
        height: 55%; /*34*/
        margin-left: 10%; /*125*/
        margin-right: 15%;
      }
  
      .title {
        display: flex;
  
        .sm_title {
          cursor: pointer;
          font-size: 1.05em; /*17*/
          font-weight: 700;
          /* color: #fff; */
          /* margin-left: 2em; //50 */
          margin-left: 3.2em; /*50*/
        }
      }
    }
  }
</style>
